import { z } from "zod";

const GOOD_VIBES_TIME_FRAMES = ["7d", "30d", "3m", "6m", "quarter", "year"] as const;
export const GoodVibesTimeFrameSchema = z.enum(GOOD_VIBES_TIME_FRAMES);
export type GoodVibesTimeFrame = z.infer<typeof GoodVibesTimeFrameSchema>;

export const DEFAULT_GOOD_VIBES_TIME_FRAME: GoodVibesTimeFrame = "30d";
